import { render } from "./PhotoTabletFormComponent.vue?vue&type=template&id=4f34bf3c"
import script from "./PhotoTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./PhotoTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__